let cartReady = false;

$(function () {
  document.documentElement.classList.add('custom-js-ready');
  document.querySelectorAll('a[href*="/cart/add"]').forEach(function(link){
    link.style.pointerEvents = '';
  });
  setTimeout(() => {
    cartReady = true;
  }, 100);

  function closeCartDrawer() {
    const $body = $('body');
    const $drawer = $body.find(".new-cart-drawer");

    $body.removeClass("open_cart_drawer");
    $drawer.children(".acart-back").removeClass("on");
    $drawer.children(".acart").removeClass("on");
    setTimeout(() => {
      $drawer.removeClass("open");
    }, 350);
  }

  function openCartDrawer() {
    if (!cartReady) return;

    const $body = $('body');
    const $drawer = $body.find(".new-cart-drawer");

    $body.addClass("open_cart_drawer");
    $drawer.addClass("open");
    $drawer.children(".acart-back").addClass("on");
    $drawer.children(".acart").addClass("on");
  }

  $(".landing-h-menu #headerCartCount").on("click", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    openCartDrawer();
  });

  $(document).on("click", function (e) {
    if (!cartReady) return;
    const $body = $('body');
    if (!$body.hasClass("open_cart_drawer")) return;
    const $drawer = $(".new-cart-drawer");
    if (!$drawer.is(e.target) && $drawer.has(e.target).length === 0) {
      closeCartDrawer();
    }
  });

  $(document).on("click", "#acartClose", function (e) {
    e.preventDefault();
    closeCartDrawer();
  });

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".disclosure").length) {
      $(".disclosure__button").attr("aria-expanded", "false");
      $("ul.disclosure__list").attr("hidden", true);
    }
  });

  if ($(window).width() > 768) {
    $('#shopNav, #megaMenu').on('mouseenter', function () {
      $('#shopNav, #megaMenu, #megaScrim').addClass('open');
    });
    $('#shopNav, #megaMenu').on('mouseleave', function () {
      setTimeout(function () {
        if (!$('#shopNav:hover').length && !$('#megaMenu:hover').length) {
          $('#shopNav, #megaMenu, #megaScrim').removeClass('open');
        }
      }, 10);
    });
  } else {
    $('#shopTrig').on('click', function (e) {
      e.preventDefault();
      $('#shopNav, #megaMenu, #megaScrim').toggleClass('open');
    });
    $('#megaScrim').on('click', function () {
      $('#shopNav, #megaMenu, #megaScrim').removeClass('open');
    });
  }

  $(document).on('click', 'details > summary', function(e) {
    e.preventDefault();
    const $details = $(this).parent('details');
    if ($details.attr('open')) {
        $details.removeAttr('open');
    } else {
        $details.attr('open', 'open');
    }
  });

  $(document).on('click', 'button.og-th', function () {
    $('button.og-th').removeClass('on');
    $(this).addClass('on');
    var newSrc = $(this).data('src');
    $('#ogMain').attr('src', newSrc);
  });

  if ($(window).width() < 749) {
    $('.landing-proof-sec .rev-row-mob-slider').slick({
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      slidesToShow: 1
    });
  } else {
    if ($('.landing-proof-sec .rev-row-mob-slider').hasClass('slick-initialized')) {
      $('.landing-proof-sec .rev-row-mob-slider').slick('unslick');
    }
  }

  if ($(window).width() < 749) {
    if (!$('.og-thumbs').hasClass('slick-initialized')) {
      $('.og-thumbs').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        focusOnSelect: true
      });
    } 
  } else {
    if ($('.og-thumbs').hasClass('slick-initialized')) {
        $('.og-thumbs').slick('unslick');
    }
  }

  // $(document).on("click", ".landing-h-menu .disclosure__button.localization-form__select", function (e) {
  //   e.preventDefault();
  //   const $btn = $(this);
  //   const isExpanded = $btn.attr("aria-expanded") === "true";
  //   $btn.attr("aria-expanded", !isExpanded);
  //   const $countryList = $btn.closest(".localization-form").find("#HeaderCountryList");
  //   if ($countryList.attr("hidden")) {
  //     $countryList.removeAttr("hidden");
  //   } else {
  //     $countryList.attr("hidden", true);
  //   }
  // });

  // $(document).on("click", "#HeaderCountryList a", function (e) {
  //   e.preventDefault();
  //   const selectedValue = $(this).data("value");
  //   const $input = $('input[type="hidden"][name="country_code"]');
  //   $input.val(selectedValue);
  //   $input.closest("form").submit();
  // });

  $(document).on("click", "#HeaderLanguageList a, #HeaderCountryList a, #HeaderDrawerCountryList a, #HeaderDrawerLanguageList a", function (e) {
    e.preventDefault();
    const $link = $(this);
    const selectedValue = $link.data("value");
    const isLanguage = $link.closest("#HeaderLanguageList, #HeaderDrawerLanguageList").length;
    const inputName = isLanguage ? "locale_code" : "country_code";
    const $input = $(`input[type="hidden"][name="${inputName}"]`);
    $input.val(selectedValue);
    $input.closest("form").submit();
  });

  $(document).on('click', '.fv', function () {
    $('.fv').removeClass('sel');
    $(this).addClass('sel');
    var flavour = $(this).data('fv');
    var variantId = $(this).data('variant-id');

    var $highlight = $('.buy-box-em');
    if ($highlight.length) {
      $highlight.text(flavour);
    }
    var $offerBtn = $('#offerBtn');
    var $offerBtn2 = $('#offerBtn2');
    var offerUrl = $offerBtn.attr('checkout_direct');
    var offerUrl2 = $offerBtn2.attr('checkout_direct');

    offerUrl = offerUrl.replace(/id=\d+/, 'id=' + variantId);
    $offerBtn.attr('href', offerUrl);
    offerUrl2 = offerUrl2.replace(/id=\d+/, 'id=' + variantId);
    $offerBtn2.attr('href', offerUrl2);

    var $singlep = $('#singlep');
    var href = $singlep.attr('href');
    href = href.replace(/id=\d+/, 'id=' + variantId);
    $singlep.attr('href', href);

    var redirect = $singlep.attr('redirect_checkout');
    redirect = redirect.replace(/id=\d+/, 'id=' + variantId);
    $singlep.attr('redirect_checkout', redirect);

  });

  async function getComparePrices(cart) {
  const cache = {};

  await Promise.all(
    cart.items.map(async (item) => {
      if (cache[item.handle]) return;
      const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
      cache[item.handle] = product;
    })
  );
  return cache;
}

function updateProgress(cart) {
  const prog = document.getElementById('acartProg');
  const fill = document.getElementById('progFill');
  const text = document.getElementById('progText');

  if (!prog || !fill || !text) return false;

  if (FREE_SHIPPING_THRESHOLD > 0) {
    const total = cart.total_price;
    const remaining = FREE_SHIPPING_THRESHOLD - total;

    if (remaining > 0) {
      const percent = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
      prog.classList.remove('unlocked');
      fill.style.width = percent + '%';
      text.innerText = `Add ${Shopify.formatMoney(remaining, window.Shopify.money_format)} more for free shipping`;
    } else {
      prog.classList.add('unlocked');
      fill.style.width = '100%';
      text.innerText = '✓ Free standard shipping unlocked';
    }
  }

  return true;
}

function updateTotals(cart) {
  const el = document.getElementById('acartTot');
  if (!el) return;

  let originalTotal = 0;

  cart.items.forEach(item => {
    originalTotal += item.original_line_price;
  });

  const discountTotal = originalTotal - cart.total_price;

  el.innerHTML = `<div class="row">
      <span class="l">Subtotal</span>
      <span class="v">${Shopify.formatMoney(originalTotal, window.Shopify.money_format)}</span>
    </div>
    ${
      discountTotal > 0
        ? `<div class="row">
            <span class="l">Discount</span>
            <span class="v">
              -${Shopify.formatMoney(discountTotal, window.Shopify.money_format)}
            </span></div>`
        : ''
    }

    <div class="grand">
      <span class="l">Total</span>
      <span class="v">
        ${Shopify.formatMoney(cart.total_price, window.Shopify.money_format)}
      </span></div>`;
}

function updateUpsell(cart) {
  const upsell = document.getElementById('acartUpsell');
  const itemsWrap = document.getElementById('acartUpsellItems');
  if (!upsell || !itemsWrap || !window.cartUpsells) return;
  const cartProductIds = cart.items.map(item => item.product_id);
  const availableProducts = window.cartUpsells.filter(product =>
    !cartProductIds.includes(product.product_id)
  );

  if (!availableProducts.length) {
    upsell.style.display = 'none';
    itemsWrap.innerHTML = '';
    return;
  }

  upsell.style.display = 'block';
  itemsWrap.innerHTML = availableProducts.slice(0, 2).map(product => {
      const price = product.subscription_price || product.regular_price;
      const comparePrice = product.subscription_price &&
        product.subscription_price < product.regular_price
          ? `
              <span class="was">
                <del>
                  ${Shopify.formatMoney(
                    product.regular_price,
                    window.Shopify.money_format
                  )}
                </del>
              </span>
            `
          : '';

      const descriptionHtml = product.description
        ? `<p>${product.description}</p>`
        : '';

      return `
        <div class="upr">
          <div class="uph">
            <img src="${product.image}" alt="${product.title}">
          </div>
          <div>
            <h5>${product.title}</h5>
            ${descriptionHtml}
            <div class="price">
              ${comparePrice}
              <strong style="color:var(--ink);">
                ${Shopify.formatMoney(
                  price,
                  window.Shopify.money_format
                )}
              </strong>
            </div>
          </div>

          <button class="add" onclick="addUpsellProduct(
              ${product.variant_id},
              ${product.selling_plan_id || 'null'})"
          >Add</button>
        </div>`;
    })
    .join('');
}

function runUpsellAfterDrawer(cart) {
  const upsell = document.getElementById('acartUpsell');
  if (!upsell) return;

  if (!cart || cart.item_count === 0) {
    upsell.style.display = 'none';
    return;
  }

  setTimeout(() => {
    updateUpsell(cart);
  }, 250);
}

  $(document).on('click', 'a[href*="/cart/add"]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var url = new URL($(this).attr('href'), window.location.origin);
    var id = url.searchParams.get('id');
    var quantity = parseInt(url.searchParams.get('quantity')) || 1;
    var selling_plan = url.searchParams.get('selling_plan');

    $('body').addClass('updating_cart');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: id,
        quantity: quantity,
        selling_plan: selling_plan
      },
      dataType: 'json',
      success: function () {
        $('.new-cart-drawer').addClass('open');
        $('.new-cart-drawer .acart-back').addClass("on");
        $('.new-cart-drawer .acart').addClass("on");

        fetch('/cart.js')
            .then(res => res.json())
            .then(async cart => {
                console.log('🛒 Updated cart:', cart);
                $('body').addClass("open_cart_drawer");
                $('#acartCt').text(`${cart.item_count} items`);
                $('#headerCartCount').text(`Cart (${cart.item_count})`);
                const checkoutBtn = document.getElementById('acartCo');
                const expressBtns = document.getElementById('expressBtns');
                if (checkoutBtn) {
                  checkoutBtn.disabled = cart.item_count === 0;
                  checkoutBtn.classList.toggle('disabled', cart.item_count === 0);
                }
                if (expressBtns) {
                  expressBtns.classList.toggle('hidden', cart.item_count === 0);
                }
                let html = '';
                if (cart.item_count === 0) {

                  html = `<div class="acart-empty">
                      <span class="em">i.</span>
                      <p>Your cart is empty</p>
                      <a href="/collections/all" class="btn btn-dark" style="display:inline-flex;">Begin Shopping</a></div>`;
                    } else {
                      
                      const productCache = await getComparePrices(cart);
                        cart.items.forEach((item, index) => {

                          const product = productCache[item.handle];
                          const variant = product?.variants.find(v => v.id === item.variant_id);
                          const vPrice = variant.price;
                          let meta = '';
                          const hasFreeGift = item.properties && item.properties["_salepify-advanced-fg"];
                            if (item.options_with_values && item.options_with_values.length) {

                              const optionsHtml = item.options_with_values.map(opt => {
                                if (!opt || !opt.name || !opt.value) return '';

                                if (opt.name.toLowerCase() === 'title' && opt.value.toLowerCase() === 'default title') {
                                  return '';
                                }
                                return `${opt.name}: ${opt.value}`;
                              })
                              .filter(Boolean).join('<br>');

                              if (optionsHtml) {
                                meta += `<div class="meta">${optionsHtml}</div>`;
                              }
                          }

                            if (item.selling_plan_allocation) {
                                meta += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
                            }

                            if (item.properties && !hasFreeGift) {
                                Object.entries(item.properties).forEach(([key, value]) => {
                                    if (!value) return;
                                    if (key === '_salepify-advanced-fg' || key == '_salepify_product_id' || key === '_salepify-ymal' || key === '_salepify-ymal-subscription') return;
                                    meta += `<div class="meta">${key}: ${value}</div>`;
                                });
                            }

                            html += `
                            <div class="ali pd-index pd-index-${index + 1} ${item.properties['_salepify-advanced-fg'] || item.properties['_salepify-embed'] || item.properties['_salepify-bogo'] ? "salepify-always-last" : ""}" data-pid="${item.id}" data-line="${index + 1}">
                                <div class="ph full">
                                    <img src="${item.image}" alt="${item.product_title}">
                                </div>
                                <div class="md">
                                    <h4>${item.product_title}</h4>
                                    ${meta}
                                    ${!hasFreeGift ? `
                                        <div class="qrow">
                                            <div class="qty">
                                                <button onclick="updateQty(${index + 1}, -1)">−</button>
                                                <span class="v">${item.quantity}</span>
                                                <button onclick="updateQty(${index + 1}, 1)">+</button>
                                            </div>
                                            <button class="rem" onclick="removeItem(${index + 1})">Remove</button>
                                        </div>
                                    ` : ''}

                                </div>

                                <div class="pr">
                                    ${
                                        vPrice > item.final_line_price
                                            ? `<span class="was">
                                                ${Shopify.formatMoney(
                                                    vPrice,
                                                    window.Shopify.money_format
                                                )}
                                               </span>`
                                            : ''
                                    }

                                    ${Shopify.formatMoney(
                                        item.final_line_price,
                                        window.Shopify.money_format
                                    )}
                                </div>

                            </div>
                            `;
                        });
                    }
                    $('#acartBody').html(html);
                });
        },
        error: function (error) {
          console.error('❌ Add to cart failed:', error);
        },
        complete: function () {
          $('body').removeClass('updating_cart');
        }

    });
  });
});